import styled from 'styled-components';
import * as colors from '../../../../common/colorConstants';
import { smallScreens } from 'components/common/fontElements';
import { HeaderRow, Row, SubTitleText } from '../../DTInfoWidget.styles';

export const OffersInfoSubTitleText = styled(SubTitleText)`
  margin-top: 15px;
`;

export const ButtonIcon = styled.button`
  all: unset;
  cursor: pointer;
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${colors.darkGray17};
  :focus,
  :hover {
    color: ${colors.blue11};
  }
`;

export const OffersInfoHeaderRow = styled(HeaderRow)`
  padding: 15px 40px 0px 29px;
  @media screen and (max-height: ${smallScreens}), screen and (max-width: ${smallScreens}) {
    padding: 10px 40px 15px 29px;
  }
`;

export const OffersInfoRow = styled(Row)`
  padding: 15px 40px 15px 29px;
  @media screen and (max-height: ${smallScreens}), screen and (max-width: ${smallScreens}) {
    padding: 10px 40px 15px 29px;
  }
`;

export const DescriptionPopupWrapper = styled.div`
  position: relative;
`;
